import React from "react";
import { View, ActivityIndicator } from "react-native";
import VideoPlayer from "../../../components/VideoPlayer";
import { useCustomTheme } from '../../../contexts/useCustomTheme';
import { StandardText } from "../../../config/theme/globalStyles";

const ViewVideo = (props) => {

  const { video, user, card } = props;
  const [ready, setReady] = React.useState(false);
  const { plans, coursesCard, productIds } = card || {};
  const { customColor } = useCustomTheme();
  const { plan: userPlan, courses: userCourses, isAdmin } = user || {};

  const toDate = (seconds) => {
    const date = new Date(1970, 0, 1);
    date.setSeconds(seconds);
    return date;
  };

  const content = (
    <>
      {(productIds &&
        productIds?.length > 0 &&
        productIds?.filter((cardProductId) => {
          const matchingUserProducts = user?.productIds?.filter(
            (userProduct) => userProduct.productId === cardProductId
          );
          if (!matchingUserProducts || matchingUserProducts.length === 0) {
            return false; // O usuário não possui este produto, então não tem acesso
          }
          // Se não houver data de expiração, ou se alguma data de expiração for maior que a data atual, o usuário tem acesso
          return matchingUserProducts.some(
            (userProduct) =>
              !userProduct.expirationDate ||
              toDate(userProduct.expirationDate.seconds) > new Date()
          );
        }).length > 0) ||
        (plans &&
          plans.length > 0 &&
          plans.filter((plan) => (plan.priceId || plan.productId) == userPlan)
            .length > 0) ||
        (userCourses &&
          userCourses.length > 0 &&
          userCourses.filter(
            (course) =>
              coursesCard?.some(
                (itemToBeRemoved) =>
                  (itemToBeRemoved.priceId || itemToBeRemoved.productId) ===
                  (course.priceId || course.productId)
              ) && toDate(course.dueDate.seconds) > new Date()
          ).length > 0) ||
        (plans == null && coursesCard == null && productIds == null) ||
        isAdmin === true ? (
        <VideoPlayer
          video={video}
          onFirstFrame={() => setReady(true)} // implemente este callback no seu player, ver nota abaixo
        />
      ) : (
        <></>
      )}
    </>
  );

  return (
    <View
      style={{
        width: "100%",
        height: "100%",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {(!ready && (video?.type === 'livestream')) && (
        <>
          <ActivityIndicator
            color={
              customColor && customColor.primary
                ? customColor.primary
                : THEME.COLORS.PRIMARY_800
            } />
          <StandardText
            color={
              customColor && customColor.text && customColor.text.app
                ? customColor.text.app
                : THEME.COLORS.TITLE_MAIN
            }
          >
            Por favor, aguarde...
          </StandardText>
        </>
      )}
      {content}
    </View>
  );
};

export default ViewVideo;
